// 询盘卡片（sakurairo/inquiry 区块）：提交到 POST sakura/v1/inquiry。
// 卡片能放正文也能当挂件放侧栏，一页还可能放好几个：每次页面加载都扫一遍，
// 用 dataset 标记只绑没绑过的那个（放正文时整块会随 pjax 换页换掉，标记也跟着没了）。
function bindInquiryForm(form) {
    const status = form.querySelector("[data-inquiry-status]");
    const submit = form.querySelector(".iro-inquiry__submit");

    const setStatus = (text, tone) => {
        if (!status) {
            return;
        }
        status.textContent = text;
        status.dataset.tone = tone;
    };

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        const payload = Object.fromEntries(new FormData(form).entries());

        submit.disabled = true;
        setStatus(_iro.i18n("提交中…"), "pending");

        try {
            const response = await fetch(`${_iro.config.iro_api}/inquiry`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": _iro.config.nonce,
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json().catch(() => ({}));

            if (!response.ok) {
                throw new Error(
                    data?.message ||
                        _iro.i18n("提交失败，请稍后再试或直接邮件联系我们。"),
                );
            }

            form.reset();
            // 内建验证码答对即作废，成功后要换一张，否则下一次提交必然对不上
            document.dispatchEvent(
                new CustomEvent("captcha:refresh", { detail: {} }),
            );
            setStatus(_iro.i18n("已收到，我们会尽快与您联系。"), "ok");
        } catch (error) {
            setStatus(error.message, "error");
        } finally {
            submit.disabled = false;
        }
    });
}

_iro.hooks.onPageLoaded(() => {
    document.querySelectorAll("[data-inquiry-form]").forEach((form) => {
        if (form.dataset.inquiryBound === "1") {
            return;
        }

        form.dataset.inquiryBound = "1";
        bindInquiryForm(form);
    });
});
